var React = require('react');

function SrpBags (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.426 1.532C.457 1.532 0 1.964 0 2.903v4.726C0 8.567.457 9 1.426 9h.792V1.532h-.792zM7.658 1.532A1.56 1.56 0 006.1 0H4.897a1.56 1.56 0 00-1.558 1.532h-.001V9H7.66V1.532h-.002zm-3.772 0A1.013 1.013 0 014.897.547H6.1c.549 0 .996.44 1.011.985H3.886zM9.571 1.532h-.79V9h.79c.968 0 1.425-.433 1.425-1.371V2.903c.001-.939-.456-1.371-1.425-1.371z"}));
}

SrpBags.defaultProps = {"width":"10.997","height":"9","viewBox":"0 0 10.997 9"};

module.exports = SrpBags;

SrpBags.default = SrpBags;
